import { startListening, appOpened } from '@bonanza-social/toolkit/state';
import { initMetaPixel } from './metaPixel.utils';
startListening({
  actionCreator: appOpened,
  effect: () => {
    initMetaPixel();
  },
});
